export const GiftFundsProvisionPeriodType = {
  PRIOR_TO_CLOSING: 'PriorToClosing',
  AT_CLOSING: 'AtClosing',
};

export const giftFundsProvisionPeriodOptions = [
  { name: 'At closing', value: GiftFundsProvisionPeriodType.AT_CLOSING },
  { name: 'Prior to closing', value: GiftFundsProvisionPeriodType.PRIOR_TO_CLOSING },
];

export const VALIDATION_DELAY_MS = 100;
